import { Autocomplete, Grid, IconButton, TextField, Typography, Box, Button, Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Add as IconAdd, Delete as IconDelete, Edit as IconEdit } from "@mui/icons-material";
import comprobanteService from "../services/comprobanteService";
import * as servicioService from "../services/servicioService";
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { init, setEntity, setData, setValidationMessage, activeValidations
  , setListConceptoCobro, defaultReceiptDetail as defaultReceiptDetailImport } from "../redux/receiptDetailSlice";
import DialogYesNo from './DialogYesNo';
import MontoTextField, { formatoMonto } from './common/MontoTextField';

// Cantidad por precio unitario, redondeado a centimos. Es el sub total de la linea.
const subTotalLinea = (precio, cantidad) => {
    const monto = (Number(precio) || 0) * (Number(cantidad) || 0);
    return Math.round((monto + Number.EPSILON) * 100) / 100;
};

const ReceiptDetail = (props) => {
    const isReadOnly = props.isReadOnly;
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const params = useParams();
    const setDetails = props.setDetails;
    // Solo se pide confirmacion al borrar si el comprobante ya esta registrado.
    const esNuevo = props.esNuevo;
    // El detalle se trae del comprobante: el identificador llega por la ruta
    // (pagina) o por prop (dialogo).
    const idComprobante = props.idComprobante != null ? props.idComprobante : params.id;

    useEffect(() => {
        dispatch(init({ sliceKey }));
    }, [dispatch, sliceKey]);

    const entity = useSelector((state) => state.receiptDetail[sliceKey]?.entity);
    const listConceptoCobro = useSelector((state) => state.receiptDetail[sliceKey]?.listConceptoCobro);
    const validate = useSelector((state) => state.receiptDetail[sliceKey]?.validationActive);
    const [listDetails, setListDetails] = useState([]);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectIndexDelete, setSelectIndexDelete] = useState(-1);

    const fetchListConceptoCobro = async () => {
        const data = await servicioService.getsConceptoCobroView({
                idServicio: 0,
                idFilial: 0,
                idTipo: 0,
                sesionesMes: 0,
                idEstado: 2,
            })
            .catch((err) => {
                console.log("Err: ", err)
            });
        dispatch(setListConceptoCobro({sliceKey: sliceKey, data: data}));
    }

    const fetchDetails = useCallback(async () => {
        if (idComprobante != null && parseInt(idComprobante) > 0) {
            const response = await comprobanteService.getsComprobanteDetalleView(idComprobante)
                .catch((err) => {
                    console.log("Err: ", err);
                });
            const details = response?.data?.data || [];

            setListDetails(details);
            if (setDetails) setDetails(details);
            return;
        }

        // Comprobante nuevo: los items pueden venir precargados por la pantalla
        // que lo abre (la tarifa del periodo y su descuento, por ejemplo). Se
        // devuelven al padre para que los tome en cuenta al calcular los totales.
        const iniciales = props.initialDetails || [];

        setListDetails(iniciales);
        if (setDetails) setDetails(iniciales);
    }, [idComprobante]);

    useEffect(() => {
        fetchListConceptoCobro();
        fetchDetails();
    }, [fetchDetails]);

    var validation = {
        cantidad: {
            error: entity?.cantidad == 0 || entity?.cantidad == null,
            message: "Ingrese la cantidad",
        },
        idConceptoCobro: {
            error: entity?.idConceptoCobro == 0 || entity?.idConceptoCobro == null,
            message: "Seleccione el concepto de cobro",
        },
        precioUnitario: {
            error: entity?.precioUnitario == 0 || entity?.precioUnitario == null,
            message: "Ingrese el precio unitario",
        },
    }

    const messagesValidation = () => {
        var messages = [];

        Object.keys(validation).forEach(function (key) {
            if (validation[key].error) messages.push(validation[key].message)
        })

        return messages;
    }

    useEffect(() => {
        dispatch(setValidationMessage({sliceKey: sliceKey, message: messagesValidation()}));
    }, [entity])

    var setDataEntity = e => {
        dispatch(setData({sliceKey: sliceKey, name: e.target.name, value: e.target.value}));
    }

    const handleAddDetail = () => {
        var messages = messagesValidation();
        if (messages.length > 0) {
            dispatch(activeValidations({sliceKey: sliceKey}));
            return;
        }

        var newDetail = {
            id: 0,
            numero: listDetails.length + 1,
            cantidad: entity.cantidad,
            cantidadStock: entity.cantidadStock || 0,
            idConceptoCobro: entity.idConceptoCobro,
            conceptoCobro: entity.conceptoCobro,
            precioUnitario: entity.precioUnitario,
            subTotal: subTotalLinea(entity.precioUnitario, entity.cantidad),
        };

        var newList = [...listDetails, newDetail];
        setListDetails(newList);
        if (setDetails) setDetails(newList);
        dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
    }

    const handleEditDetail = (index) => {
        setEditingIndex(index);
        dispatch(setEntity({sliceKey: sliceKey, data: listDetails[index]}));
    }

    const handleUpdateDetail = () => {
        var messages = messagesValidation();
        if (messages.length > 0) {
            dispatch(activeValidations({sliceKey: sliceKey}));
            return;
        }

        var updatedDetail = {
            ...listDetails[editingIndex],
            cantidad: entity.cantidad,
            cantidadStock: entity.cantidadStock || 0,
            idConceptoCobro: entity.idConceptoCobro,
            conceptoCobro: entity.conceptoCobro,
            precioUnitario: entity.precioUnitario,
            subTotal: subTotalLinea(entity.precioUnitario, entity.cantidad),
        };

        var newList = [...listDetails];
        newList[editingIndex] = updatedDetail;
        setListDetails(newList);
        if (setDetails) setDetails(newList);
        setEditingIndex(-1);
        dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
    }

    const eliminarDetail = (index) => {
        var newList = listDetails.filter((_, i) => i !== index);
        setListDetails(newList);
        if (setDetails) setDetails(newList);

        if (editingIndex === index) {
            setEditingIndex(-1);
            dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
        }
    }

    const handleDeleteDetail = (index) => {
        if (esNuevo) {
            eliminarDetail(index);
            return;
        }

        setSelectIndexDelete(index);
        openCloseDialogDelete();
    }

    const handleCancelEdit = () => {
        setEditingIndex(-1);
        dispatch(setEntity({sliceKey: sliceKey, data: defaultReceiptDetailImport}));
    }

    return (
        <Grid container>
            <Grid item xs={12}>
                <Box sx={{ fontWeight: 'bold' }} padding={0}>
                    <Typography variant="h7">
                        Detalle del Comprobante
                    </Typography>
                </Box>
            </Grid>
            {/* Los campos para agregar un detalle solo aparecen cuando se pueden
                agregar. Si el comprobante ya tiene pagos, el detalle no se edita y
                la fila de captura no se muestra: se ahorra el espacio. */}
            {!isReadOnly && (
            <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                <Grid item xs={6} sm={2}>
                    <TextField
                        required
                        name="cantidad"
                        label="Cantidad"
                        fullWidth
                        type="number"
                        value={entity?.cantidad || 0}
                        onChange={setDataEntity}
                        error={validate?.cantidad && validation.cantidad.error}
                        helperText={validate?.cantidad && validation.cantidad.error ? validation.cantidad.message : ""}
                        disabled={isReadOnly}
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ min: 1, style: { textAlign: "right" } }}
                    />
                </Grid>
                <Grid item xs={8} sm={4}>
                    <Autocomplete
                        options={(listConceptoCobro || []).filter((row) => row.id)}
                        value={(listConceptoCobro || []).find((row) => row.id && row.id == entity?.idConceptoCobro) || null}
                        onChange={(event, newValue) => {
                            dispatch(setData({sliceKey: sliceKey, name: "idConceptoCobro", value: newValue?.id || 0}))
                            dispatch(setData({sliceKey: sliceKey, name: "conceptoCobro", value: newValue?.descripcion || ""}))
                            if (newValue) {
                                dispatch(setData({sliceKey: sliceKey, name: "precioUnitario", value: newValue.monto}))
                            }
                        }}
                        getOptionLabel={(option) => option?.descripcion || ""}
                        isOptionEqualToValue={(option, value) => option.id == value.id}
                        disabled={isReadOnly}
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                required
                                label="Concepto de Cobro"
                                size="small"
                                error={validate?.idConceptoCobro && validation.idConceptoCobro.error}
                                helperText={validate?.idConceptoCobro && validation.idConceptoCobro.error ? validation.idConceptoCobro.message : ""}
                                InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <MontoTextField
                        required
                        name="precioUnitario"
                        label="Precio Unitario"
                        fullWidth
                        value={entity?.precioUnitario ?? ""}
                        onChange={setDataEntity}
                        error={validate?.precioUnitario && validation.precioUnitario.error}
                        helperText={validate?.precioUnitario && validation.precioUnitario.error ? validation.precioUnitario.message : ""}
                        disabled={isReadOnly}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <MontoTextField
                        disabled
                        name="subTotal"
                        label="Sub Total"
                        fullWidth
                        value={subTotalLinea(entity?.precioUnitario, entity?.cantidad)}
                        size="small"
                    />
                </Grid>
                <Grid item xs={6} sm={2}>
                    <Box display="flex" alignItems="center" gap={1}>
                        {editingIndex >= 0 ? (
                            <>
                                <Button variant="contained" size="small" onClick={handleUpdateDetail} disabled={isReadOnly}>
                                    Actualizar
                                </Button>
                                <Button variant="outlined" size="small" onClick={handleCancelEdit}>
                                    Cancelar
                                </Button>
                            </>
                        ) : (
                            <Tooltip title="Agregar">
                                <Button variant="contained" size="small" onClick={handleAddDetail} aria-label="Agregar" sx={{ minWidth: 40 }}>
                                    <IconAdd />
                                </Button>
                            </Tooltip>
                        )}
                    </Box>
                </Grid>
            </Grid>
            )}
            {/* La tabla del detalle siempre se muestra. */}
            <Grid item xs={12} sx={{ mt: isReadOnly ? 1 : 2 }}>
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 'bold' }}>N°</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Cantidad</TableCell>
                                <TableCell sx={{ fontWeight: 'bold' }}>Concepto de Cobro</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Precio Unitario</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>Sub Total</TableCell>
                                {/* La columna de acciones solo se muestra si el
                                    detalle se puede modificar. */}
                                {!isReadOnly && (
                                    <TableCell align="center" sx={{ fontWeight: 'bold' }}>Acciones</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listDetails.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">{index + 1}</TableCell>
                                    <TableCell align="right">{row.cantidad}</TableCell>
                                    <TableCell>{row.conceptoCobro}</TableCell>
                                    <TableCell align="right">{formatoMonto(row.precioUnitario)}</TableCell>
                                    <TableCell align="right">{formatoMonto(row.subTotal)}</TableCell>
                                    {!isReadOnly && (
                                        <TableCell align="center">
                                            <IconButton size="small" onClick={() => handleEditDetail(index)}>
                                                <IconEdit fontSize="small" />
                                            </IconButton>
                                            <IconButton size="small" onClick={() => handleDeleteDetail(index)}>
                                                <IconDelete fontSize="small" />
                                            </IconButton>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                            {listDetails.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={isReadOnly ? 5 : 6} align="center">
                                        <Typography variant="body2" color="textSecondary">
                                            No hay detalles agregados
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={() => eliminarDetail(selectIndexDelete)}
                setNo={() => { return }}
                titulo={"Borrar Detalle"}
                texto={"Esta seguro de borrar el detalle del comprobante?"}
            ></DialogYesNo>
        </Grid>
    );
}
export default ReceiptDetail;
